export default __webpack_public_path__ + "static/media/arequipa-street_trafic.81fa46fd.jpg";